import { render } from "./DocumentViewer.vue?vue&type=template&id=a42e976a&scoped=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&lang=js"

import "./DocumentViewer.vue?vue&type=style&index=0&id=a42e976a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42e976a"]])

export default __exports__